import { useState, useEffect } from 'react';
import api from '../../../api';

export const useDepartments = (tenantId, shouldFetch) => {
  const [departments, setDepartments] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!tenantId || !shouldFetch) return;

    const fetchDepartments = async () => {
      setLoading(true);
      setError(null);
      try {
        const token = localStorage.getItem('token');
        const headers = token ? { Authorization: `Bearer ${token}` } : {};
        const res = await api.get(`/api/departments/${tenantId}`, { headers });
        // adjust to your response shape
        const list = res.data?.departments || res.data || [];
        setDepartments(Array.isArray(list) ? list : []);
      } catch (err) {
        console.error('Error fetching departments:', err?.response?.data || err);
        setError('Failed to load departments');
        setDepartments([]);
      } finally {
        setLoading(false);
      }
    };

    fetchDepartments();
  }, [tenantId, shouldFetch]);

  return { departments, loading, error };
};